import { z } from "zod";
export const messageRoleSchema = z.enum(["user", "assistant"]);
export const messageInputSchema = z.object({
    userId: z.string().min(1),
    role: messageRoleSchema,
    content: z.string().min(1),
    toolCalls: z.array(z.unknown()).optional(),
    toolResults: z.array(z.unknown()).optional(),
});
export const messageSchema = messageInputSchema.extend({
    id: z.string().min(1),
    createdAt: z.string().min(1),
});
//# sourceMappingURL=message.js.map